type MobileLogoComponentPropsType = {
  className?: string;
};

function MobileLogoComponent({ className }: MobileLogoComponentPropsType) {
  return (
    // For future use
    // <img
    //   alt="WESTERN TECH LOGO"
    //   className={className}
    //   src="https://www.westerntech.edu/wp-content/uploads/2025/01/WTC-Logo-55-Esmeral-Green-e1738179851378.png"
    // />
    <h1 className={`m-0 ${className}`}>WT</h1>
  );
}
export default MobileLogoComponent;
